import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function headerCell(theme: Theme): ComponentStyle {
  return {
    componentName: 'headerCell',
    baseStyle: {
      borderBottom: `1px solid ${theme.colors.border}`,
      fontWeight: 500,
      color: theme.colors.muted,
      fontSize: theme.sizes['-1'],

      '&:first-child': {
        marginLeft: theme.space['s']
      },

      '&:last-child': {
        marginRight: theme.space['s']
      }
    },
    variants: {
      insideCard: {
        '&:first-child': {
          marginLeft: 0
        },

        '&:last-child': {
          marginRight: 0
        }
      }
    }
  };
}
